<template>
  <div class="home">
    <!-- 引入elementui布局容器:el-container -->
    <el-container>
      <!-- 1.头部 -->
      <el-header>
        <div>
          <img src="https://s3.bmp.ovh/2026/01/26/4rDoNVBU.png" alt="userAvatar.png" />
          <span class="title">Gaara网络科技有限公司后台管理系统</span>
        </div>
        <el-button type="success" @click="logOut" size="mini"
          >退出登录</el-button
        >
      </el-header>
      <!-- 2.侧边栏和主体内容 -->
      <el-container>
        <!-- 2.1.侧边栏 -->
        <!-- <el-aside width="200px">改成动态宽度: -->
        <el-aside class="elaside" :width="isopen ? '200px' : '50px'">
          <!-- 切换宽度动画区域:点击就会变窄和变宽 -->
          <div class="togglebtn" @click="switchMenu">
              <i :class="isopen?'el-icon-s-fold':'el-icon-s-unfold'"></i>
            </div>
          <!-- 使用el-menu进行aside侧边栏布局 -->
          <!-- 左侧菜单区域 -->
          <!-- <el-menu default="2" class="el-menu-vertival-deme"> -->
          <el-menu
            class="el-menu-vartical-demo"
            :unique-opened="true"
            background-color="#121a2a"
            text-color="#fff"
            :router="true"
          >
            <!-- 一级菜单 -->
            <!-- <el-submenu index="1"> 改成动态绑定: -->
              <el-submenu :index="item.id+''" v-for="item in menulist" :key="item.id">
              <!-- 一级菜单的模板 -->
              <template slot="title">
                <!-- 菜单图标 -->
                <!-- <i class="el-icon-location"></i> -->
                <i :class="iconObj[item.id]"></i>
                <!-- 文本 -->
                <!-- <span>导航1</span> -->
                <span>{{item.name}}</span>
              </template>
              <!-- 一级菜单下的二级菜单 -->
              <!-- <el-menu-item index="1-4"> 改成动态绑定: -->
                <el-menu-item :index="subitem.path" v-for="subitem in item.child" :key="subitem.id">
                <!-- 二级菜单的模板 -->
                <template slot="title">
                  <!-- 二级菜单图标 -->
                  <!-- <i class="el-icon-location"></i> -->
                  <i :class="iconObj2[subitem.name]"></i>
                  <!-- 二级菜单文本 -->
                  <!-- <span>二级菜单</span> -->
                  <span>{{subitem.name}}</span>
                </template>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <!-- 2.2.主体内容 -->
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  props: [],
  data () {
    return {
      // loginObj: {
      //   username: "admin",
      //   password: 123456,
      // },
      menulist: [],
      isopen: true,
      iconObj: {
        1: 'el-icon-user-solid',
        2: 'el-icon-user',
        3: 'el-icon-shopping-bag-1',
        4: 'el-icon-s-claim',
        5: 'el-icon-collection',
        6: 'el-icon-pie-chart'
      },
      iconObj2: {
        用户管理: 'el-icon-s-custom',
        员工管理: 'el-icon-s-custom',
        商品管理: 'el-icon-s-custom',
        订单管理: 'el-icon-s-custom',
        数据统计: 'el-icon-s-custom',
        用户列表: 'el-icon-s-custom',
        员工列表: 'el-icon-s-order',
        权限列表: 'el-icon-s-custom',
        商品列表: 'el-icon-shopping-cart-2',
        分类参数: 'el-icon-files',
        商品分类: 'el-icon-postcard'
      }
    }
  },
  watch: {},
  computed: {},
  methods: {
    logOut () {
      // 清空数据
      window.sessionStorage.clear()
      // 点击退出登录后自动跳转到登录页
      this.$router.push('/login')
    },
    async getmenus () {
      // 这里对标的是vue.config.js中的"./api/menu"
      const res = await this.$http.get(`${this.$BASE_URL}/api/menu`)
      // console.log(res.data)
      if (!res.status === 'ok') return
      this.menulist = res.data.data
    },
    switchMenu () {
      this.isopen = !this.isopen
    }
  },
  created () {
    this.getmenus()
  },
  mounted () {}
}
</script>
<style lang="scss" scoped>
/*home主页的样式 */

.el-container {
  height: 100vh;
}
/*头部header的样式*/
.el-header {
  display: flex;
  /* el-header下的子元素会显示在两边 */
  justify-content: space-between;
  align-items: center;
  background: #0c212b;
  height: 80px !important;
}
.el-header > div {
  display: flex;
  align-items: center;
}
.el-header img {
  width: 60px;
  height: 60px;
  padding-right: 16px;
}
.el-header .title {
  color: #fff;
  font-size: 30px;
}
/* Aisde侧边栏的样式*/
.el-aside {
  background: #d3dce6;
  line-height: 400px;
}
.togglebtn{
  height:24px;
  color:#fff;
  text-align: left;
  line-height: 24px;
  font-size:16px;
  padding-left:10px;
  // background: darkcyan;
  background:#0c212b;
  cursor:pointer;
}
.elaside{
  transition:all .3s ease;
}
/*Main主体样式*/
.el-main {
  background: #e9eef3;
}

.el-menu-item{
  padding-left:60px !important;
}
</style>
